import React from "react";
import ReactDOM from "react-dom/client";
import Clarity from "@microsoft/clarity";
import "./index.css";
import "./styles/GameModules.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

// Initialize Microsoft Clarity (production only)
if (process.env.NODE_ENV === "production") {
  Clarity.init("v90q8j5kac"); 
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
